import { IReportService } from "../../service/report/ReportService";

export default class GetReport6DataInteractors {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(applicantIds: number[], reportingPeriodId?: number) {
    return this.reportService.getReport6Data(applicantIds, reportingPeriodId);
  }
}
